import { makeStyles } from "@material-ui/core/styles";
import { MuiTheme } from "theme";

export default makeStyles((theme: MuiTheme) => {
  const { dark: activeTabColor } = theme.palette.secondary;

  return {
    appPage: {
      background: "#f6fbfa"
    },
    appPageHeader: {
      height: "initial",
      zIndex: theme.zIndex.page?.header + 1
    },
    tabBar: {
      "& .mdc-tab": {
        fontSize: 14,
        height: 40,
        maxWidth: 180,
        padding: "0 20px",
        "& .mdc-tab__content": {
          paddingTop: 0,
          textTransform: "uppercase",
          alignItems: "center"
        }
      },
      "& .mdc-tab--active .mdc-tab__content": {
        "& .mdc-tab__text-label": {
          color: activeTabColor
        }
      },
      "& .mdc-tab--active .mdc-tab-indicator > .mdc-tab-indicator__content--underline":
        {
          backgroundColor: activeTabColor
        }
    }
  };
});
